import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';

const UtmToRoute = () => {
  const location = useLocation();

  useEffect(() => {
    const utmToUrl = async () => {
      const stored = sessionStorage ? sessionStorage.getItem('redirect_utm') : null;
      const url = new URL(window.location.href);
      let modified = false;

      if (stored) {
        try {
          const utms = JSON.parse(stored);
          await Promise.all(_.map(utms, (value, key) => {
            if (!url.searchParams.has(key)) {
              url.searchParams.set(key, value);
              modified = true;
            }
          }));
        } catch (e) {
          //
        }
      }

      if (modified) {
        window.history.replaceState({}, '', url);
      }
    };

    utmToUrl();
  }, [location]);

  return null;
};

export default UtmToRoute;
